import React from 'react';
import './Login.css'
import quochuy from '../../assets/img/quoc-huy-vector.jpg'
import Footer from '../footer/footer';

const Login = ({ handleLogin }) => {
   
        return (
            <div className="login-layout">

           <div className="login-page">
  <div className="login-background-overlay"></div>

  <div className="login-top-logo">
  <img src={quochuy} className="quochuy" alt="logo" />

    <h3 className="login-top-logo-title">
      ỦY BAN NHÂN DÂN TỈNH AN GIANG
    </h3>

    <h1 className="login-top-logo-heading">
      SỞ CÔNG THƯƠNG
    </h1>

    <p className="login-top-logo-desc">
      HỆ THỐNG DỮ LIỆU NGÀNH CÔNG THƯƠNG
    </p>
  </div>

  <div className="login-form-wrapper">
    <div className="login-form-header">
      <div className="login-form-header-icon">
        <i className="fa-regular fa-circle-user"></i>
      </div>

      <h2 className="login-form-header-title">
        Đăng nhập hệ thống
      </h2>
    </div>

    <div className="login-form-header-line"></div>

    <div className="login-form-group">
      <label className="login-form-label">
        Tên đăng nhập
      </label>

      <div className="login-form-input-wrapper">
        <i className="fa-regular fa-user login-form-input-icon"></i>

        <input
          className="login-form-input"
          type="text"
          placeholder="Nhập tên đăng nhập"
        />
      </div>
    </div>

    <div className="login-form-password-group">
      <label className="login-form-password-label">
        Mật khẩu
      </label>

      <div className="login-form-password-wrapper">
        <i className="fa-solid fa-lock login-form-password-icon"></i>

        <input
          className="login-form-password-input"
          type="password"
          placeholder="Nhập mật khẩu"
        />

        <i className="fa-regular fa-eye login-form-password-eye"></i>
      </div>
    </div>

    <div className="login-form-remember">
      <input
        className="login-form-remember-checkbox"
        type="checkbox"
        checked
      />

      <span className="login-form-remember-text">
        Ghi nhớ đăng nhập
      </span>
    </div>

    <button className="login-form-button">
      <i className="fa-solid fa-right-to-bracket"></i>

      <span className="login-form-button-text" onClick={handleLogin}>
        ĐĂNG NHẬP
      </span>
    </button>

    <div className="login-form-forgot">
      Quên mật khẩu?
    </div>
  </div>

  <div className="login-bottom-left"></div>

  <div className="login-bottom-right"></div>

  <div className="login-bottom-wave"></div>
  
</div>

<Footer/>
            </div>
        );
    }


export default Login;